import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#F6F4EF] border-t border-[#E6E4DF]">
      <div className="container-x py-14">
        <div className="grid md:grid-cols-4 gap-10 pb-10 border-b border-[#E6E4DF]">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <img src="/logo-transparent.png" alt="OptiSolaires" className="w-8 h-8 object-contain" />
              <p className="font-semibold text-[17px] text-[#0F1A2A]">OptiSolaires</p>
            </div>
            <p className="text-[15px] text-[#6B7280] max-w-sm">
              Nettoyage et maintenance de panneaux photovoltaïques à l'eau pure osmosée.
              Interventions partout en France.
            </p>
          </div>

          <div>
            <p className="text-[13px] uppercase tracking-wider text-[#6B7280] mb-4">Navigation</p>
            <ul className="space-y-2 text-[15px]">
              <li><Link to="/" className="hover:text-[#1E5A9C]">Accueil</Link></li>
              <li><Link to="/expertise" className="hover:text-[#1E5A9C]">Expertise</Link></li>
              <li><Link to="/methode" className="hover:text-[#1E5A9C]">Méthode</Link></li>
              <li><Link to="/contact" className="hover:text-[#1E5A9C]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-[13px] uppercase tracking-wider text-[#6B7280] mb-4">Contact</p>
            <ul className="space-y-2 text-[15px]">
              <li>
                <a href="mailto:optisolaires@gmail.com" data-testid="footer-email" className="hover:text-[#1E5A9C]">
                  optisolaires@gmail.com
                </a>
              </li>
              <li className="text-[#6B7280]">Réponse sous 24 h</li>
              <li className="text-[#6B7280]">20 rue de la Chocolaterie, Blois 41000</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-[13px] text-[#6B7280]">
          <p>© {new Date().getFullYear()} OptiSolaires</p>
          <p>Maintenance photovoltaïque · France entière</p>
        </div>
      </div>
    </footer>
  );
}
